var _g, _rect, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgPlaceholderCard = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 49,
  height: 27,
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#placeholder-card_svg__a)",
  fill: "#9A97A4"
}, /*#__PURE__*/React.createElement("path", {
  d: "M13.551 8.5c0-.663.28-1.299.78-1.768A2.754 2.754 0 0 1 16.214 6h15.98c.706 0 1.384.263 1.883.732.5.47.78 1.105.78 1.768v10c0 .663-.28 1.299-.78 1.768-.5.469-1.177.732-1.883.732h-15.98a2.754 2.754 0 0 1-1.883-.732 2.425 2.425 0 0 1-.78-1.768v-10Zm2.663-1.25c-.353 0-.692.132-.941.366-.25.235-.39.552-.39.884v1.25h18.643V8.5c0-.332-.14-.65-.39-.884a1.377 1.377 0 0 0-.942-.366h-15.98Zm17.312 5H14.883v6.25c0 .331.14.65.39.884.25.234.588.366.941.366h15.98c.353 0 .692-.132.941-.366.25-.235.39-.553.39-.884v-6.25Z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M16.214 16c0-.332.14-.65.39-.884.25-.234.589-.366.942-.366h1.332c.353 0 .692.132.941.366.25.235.39.553.39.884v1.25c0 .331-.14.65-.39.884-.25.234-.588.366-.941.366h-1.332c-.353 0-.692-.132-.942-.366a1.213 1.213 0 0 1-.39-.884V16Z"
}))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
  x: 0.5,
  y: 0.5,
  width: 48,
  height: 26,
  rx: 3.5,
  stroke: "#E2E0DB"
})), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "placeholder-card_svg__a"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  transform: "translate(10 6)",
  d: "M0 0h29v15H0z"
})))));
export default SvgPlaceholderCard;